import FetchStatus from "@/constants/fetch-status/FetchStatus";
import GeneratorShaftUnbalanceActions from "./GeneratorShaftUnbalanceActions";
import GeneratorShaftUnbalanceMutations from "./GeneratorShaftUnbalanceMutations";

const state = {
	status:             FetchStatus.Init,
	operatingRange:     0,
	successMessage:     "",
	errorMessage:       "",
	operatingRange:     0,
	orderChartData:     [],
	frequencyChartData: [],
	orderLayout:        [],
	frequencyLayout:    [],
	signalSettingIds:   [],
};

const { mutations } = GeneratorShaftUnbalanceMutations;

const { actions } = GeneratorShaftUnbalanceActions;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
};
